import { ModalContext } from '@sketch/components'
import { useCallback, useContext } from 'react'
import { LicenseAgreementModal } from './LicenseAgreementModal'
import { useGetLicenseAgreementQuery } from '@sketch/gql-types'

interface UseLicenseAgreementProps {
  shareIdentifier: string
}

export const useLicenseAgreement = ({
  shareIdentifier,
}: UseLicenseAgreementProps) => {
  const { showModal } = useContext(ModalContext)

  const { data } = useGetLicenseAgreementQuery({
    variables: { shareIdentifier },
  })

  const agreement = data?.share?.licenseAgreement?.body
  const hasLicenseAgreement = !!agreement

  const preventiveShowLicenseAgreementModal = useCallback(
    ({
      helpText = 'Read and agree to the License Agreement for this Document.',
      agreeAction,
    }: {
      helpText: string
      agreeAction: () => void
    }) => {
      if (hasLicenseAgreement) {
        showModal(LicenseAgreementModal, {
          agreement,
          helpText,
          agreeAction,
        })
      } else {
        agreeAction()
      }
    },
    [agreement, hasLicenseAgreement, showModal]
  )

  return {
    hasLicenseAgreement,
    showLicenseAgreementModal: preventiveShowLicenseAgreementModal,
  }
}
